import React, { Fragment, useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import {
  Add,
  FileCopySharp,
} from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { WithApp } from 'contexts/appContext';
import { Toasty, useToasty } from 'hooks/Toasty';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import ButtonDelete from 'hooks/ButtonDelete';
import { ConstantPermissions } from 'contexts/useConstant';
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { wsFindBy } from 'services/WService';
import { wsGet } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Cod. Ruta', accessor: 'route_code', width: 130 },
  { Header: 'Ruta', accessor: 'route_description' },
  { Header: 'Mesa', accessor: 'bureau_description' },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProgConfigShow(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify, showNotify] = useToasty();

  const [model, setOpen] = useModal();
  const [data, setData] = useState([]);
  const [config, setConfig] = useState([]);

  async function loadConfig() {
    let response = await wsGet(`prog/program-config/${id}`);
    if (response.success) setConfig(response.data);
  }

  async function listDatas() {
    let response = await wsFindBy('prog/program-config-detail', {prog_configuration_distribution_id: id});
    if (response.success) {
      setData(response.data);
    }
  }

  useEffect(() => {
    listDatas();
    loadConfig();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          id={id}
          config={config}
          reload={listDatas}
        />
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}
            component={
              <CardIcon color="primary">
                <FileCopySharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado de rutas para configuración</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={`Rutas para configuracion`}
            formatDate="DD-MM-YYYY"
            defaultWidth={1500}
            columns={columns}
            data={data.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
                        <ButtonDelete
                          entity="prog/program-config-detail"
                          id={item.id}
                          reload={() => {listDatas();}}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  route_code: item.route?.code,
                  route_description: item.route?.description,
                  bureau_code: item.bureau?.code,
                  bureau_description: item.bureau?.description,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
